const style = (theme) => ({
  fullWidth: {
    background: 50,
    width: 160,
    '& > div:first-of-type': {
      paddingTop: 0,
    },
    '& .MuiFormControl-root.MuiTextField-root': {
      '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
        '& fieldset.MuiOutlinedInput-notchedOutline': {
          borderColor: 'rgba(0, 0, 0, 0.23)',
          borderWidth: '1px',
        },
      },
      '&[aria-describedby]': {
        '& .MuiInputBase-root.MuiOutlinedInput-root.MuiInputBase-formControl': {
          '& fieldset.MuiOutlinedInput-notchedOutline': {
            borderColor: '#2933C5',
            borderWidth: '2px',
          },
        },
      },
    },
    '& input.MuiInputBase-input': {
      paddingRight: 0,
    },
    '& [aria-describedby]': {
      '& .MuiSvgIcon-root': {
        padding: 3,
      },
    },
    '& .MuiIconButton-root': {
      padding: 3,
    },
  },
  popover: {
    '& > .MuiPaper-root': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(0),
      padding: theme.spacing(2),
      minWidth: 250,
      width: 250,
      borderRadius: 8,
    },
  },
  popperDisablePortal: {
    position: 'relative !important',
    transform: 'none !important',
  },
  paper: {
    boxShadow: 'none',
    margin: 0,
    fontSize: 14,
  },
  option: {
    padding: '8px 4px',
    '&.multiple': {
      padding: 0,
      '&[aria-selected="true"]': {
        background: 'inherit',
      },
      '&[data-focus="true"]': {
        background: 'rgba(0, 0, 0, 0.04)',
        borderRadius: 3,
      },
    },
  },
  buttonContainer: {
    marginTop: theme.spacing(1),
    display: 'flex',
    justifyContent: 'center',
    '& > button': {
      flex: 1,
      '&:nth-of-type(2)': {
        marginLeft: theme.spacing(1),
      },
    },
  },
  optionItem: {
    display: 'flex',
    alignItems: 'center',
  },
  checkbox: {
    marginLeft: 0,
    marginRight: 0,
  },
  optionLabel: {
    whiteSpace: 'nowrap',
    textOverflow: 'ellipsis',
    overflow: 'hidden',
    maxWidth: 180,
    '&.multiple': {
      maxWidth: 160,
    },
  },
  addLabel: {
    color: '#1cb69a',
    marginRight: 8,
    fontSize: 14,
  },
})

export default style
